import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'
import { ApiService } from './api.service';

//  import { UserRS } from './../myservice/userrs';
//  import { SifrDataService } from './../myservice/sifrdata';
// http://app.fotopoint.hr/newmedicapi/newlogin.php?username='dalagic'&password='dalagic'
// http://app.fotopoint.hr/demowupravitelj/S_wkorlogin.php?username="1"&password="1"

@Injectable()
export class AuthenticationService {
// userRS : UserRS ;
    constructor(private http: Http, private api: ApiService) { }

    login(username: string, password: string) {
       //  return this.api.get('newlogin.php?username="'+username+'"&password="'+password+'"')
       //   return this.api.get('S_newlogin.php?username="'+username+'"&password="'+password+'"')

        ////console.log(this.api.url+'S_wkorlogin.php?username="'+username+'"&password="'+password+'"') ;
         //console.log("username / password "+username +" / "+password) ;
      // orig  15.10.2019      return this.api.get('S_wkorlogin.php?username="'+username+'"&password="'+password+'"')
     // test     15.10.2019    return this.api.get('S_wkorloginp1k2.php?username="'+username+'"&password="'+password+'"')
      return this.api.get('S_wkorlogin.php?username="'+username+'"&password="'+password+'"')
        .map((response: Response) => {
            let user = response.json();
              if(user.length!=0) {
                localStorage.setItem('currentUserw', user[0].user_id);
                  localStorage.setItem('user_idw', user[0].user_id);
                    localStorage.setItem('user_unamew', user[0].user_uname);
                      localStorage.setItem('user_passw', user[0].user_pass);
                        localStorage.setItem('user_fnamew', user[0].user_fname);
              //  console.log("user[0].user_id "+user[0].user_id) ;
              //  console.log("user[0].user_uname "+user[0].user_uname) ;
              //  console.log("user[0].user_pass "+user[0].user_pass) ;
              //  console.log("user[0].user_fname "+user[0].user_fname) ;
  
 //console.log("localStorage.getItem('currentUser'   : )"+localStorage.getItem('currentUser')) ;
                return localStorage.getItem('currentUserw');
}
  // zvonko.cuvalo@datarius.hr
// zcuvalo123
//  this.userRS.user_id  = user[0].user_id ;  
//     this.userRS.user_uname  = user[0].user_uname ;  
//      this.userRS.user_pass  = user[0].user_pass ;  
//       this.userRS.user_fname = user[0].user_fname ;  
//   this.sifrdataservice.serviceUserRS = this.userRS ;
            });
    }
    logout() {
    // remove user from local storage to log user out
        localStorage.removeItem('currentUserw');
        localStorage.removeItem('user_idw');
        localStorage.removeItem('user_unamew');
        localStorage.removeItem('user_passw');
        localStorage.removeItem('user_fnamew');
    }
} 



// WEBPACK FOOTER //
// ./src/app/providers/authentication.service.ts